export function isResourceDictionary(item) {
    return typeof item === "object" && !Array.isArray(item);
}
//# sourceMappingURL=localeProvider.js.map